export default "__VITE_ASSET__D0NK5n$Q__"